/* eslint-disable react/prop-types */
import React from 'react';
import { AllPositionsList, TeamCards } from '..';
import TeamsBackground from '../TeamCards/components/TeamsBackground';

import Social from '../../shared/Social';

import styles from './styles.module.scss';

export const IFrame = ({ comeetPositions, queryParams, teamId, name }) => {
    if (name === 'Socials') {
        return (
            <div className={styles.socials}>
                <Social />
            </div>
        );
    } else if (name === 'Teams') {
        return <TeamCards comeetPositions={comeetPositions} />;
    } else if (name === 'Teams Background') {
        return <TeamsBackground />;
    } else {
        return (
            <AllPositionsList
                comeetPositions={comeetPositions}
                queryParams={queryParams}
                teamId={teamId}
                title={name}
            />
        );
    }
};
